import React from "react";
import "./style.css";
import Overview from "../Overview";
import Bookings from "../Bookings";
import Trainers from "../Trainers";
import { Constants } from "../../../../common/constants";

const OVERVIEW_ICON = require('../../../../assets/images/vpt/overview.svg')
const OVERVIEW_SELECTED_ICON = require('../../../../assets/images/vpt/overview-selected.svg')
const BOOKINGS_ICON = require('../../../../assets/images/vpt/bookings.svg')
const BOOKINGS_SELECTED_ICON = require('../../../../assets/images/vpt/bookings-selected.svg')
const TRAINERS_ICON = require('../../../../assets/images/vpt/trainers.svg')
const TRAINERS_SELECTED_ICON = require('../../../../assets/images/vpt/trainers-selected.svg')

const SECTION_OVERVIEW = 0;
const SECTION_TRAINERS = 1;
const SECTION_BOOKINGS = 2;

class Home extends React.Component {

    constructor(props) {
        super(props);
        let storedState = localStorage.getItem(Constants.STATE_VPT_HOME);
        if (storedState)
            storedState = JSON.parse(storedState);
        this.state = storedState ? storedState : { selectedSection: SECTION_BOOKINGS };
    }
    
    componentWillUnmount() {
        localStorage.setItem(Constants.STATE_VPT_HOME, JSON.stringify(this.state));
    }

    render() {
        return (
            <div style={style.content}>
                <div className="header">VPT Admin Dashboard - {this.getHeader()}</div>
                <div style={{
                    display: "flex",
                    flexDirection: "column"
                }}>
                    <div className="section-container">
                        {this.renderSection(SECTION_BOOKINGS, "Bookings", BOOKINGS_ICON, BOOKINGS_SELECTED_ICON)}
                        {this.renderSection(SECTION_TRAINERS, "Trainers", TRAINERS_ICON, TRAINERS_SELECTED_ICON)}
                    </div>
                    <div className="box">
                        {this.getContent()}
                    </div>
                </div>
            </div>
        )
    }

    renderSection = (sectionID, title, icon, icon_selected) => <div className={`unselectable section ${this.state.selectedSection == sectionID ? "section-active" : ""}`} onClick={() => {
        if (this.state.selectedSection != sectionID) {
            this.setState({
                selectedSection: sectionID
            })
        }
    }}>
        {this.state.selectedSection == sectionID ?
            <img src={icon_selected} style={{ marginRight: 10 }} height="15px" />
            :
            <img src={icon} style={{ marginRight: 10 }} height="15px" />
        }
        <div className={`label ${this.state.selectedSection == sectionID ? "label-active" : ""}`}>{title.toUpperCase()}</div>
    </div>

    getHeader = () => {
        switch (this.state.selectedSection) {
            case SECTION_OVERVIEW:
                return "Overview";
            case SECTION_BOOKINGS:
                return "Bookings";
            case SECTION_TRAINERS:
                return "Trainers";
        }
    }

    getContent = () => {
        switch (this.state.selectedSection) {
            case SECTION_OVERVIEW:
                return <Overview />;
            case SECTION_BOOKINGS:
                return <Bookings />;
            case SECTION_TRAINERS:
                return <Trainers history={this.props.history} />;
        }
    }
}

const style = {
    content: {
        display: "flex",
        flex: 1,
        flexDirection: 'column',
        padding: "10px",
    }
}

export default Home